import { jackPotStore } from '../../store/jackPotStore';
import { jackpotConnection } from '../socketConnection/jackpotConnection';

class JackpotService {
  handleJackpotResult(data) {
    jackPotStore.setJackpotAmounts(data);
  }

  handleJackpotWin(data) {
    jackPotStore.setJackpotWinInfo(data);
  }

  handleJackpotWinnerInfoResult(data) {
    jackPotStore.setJackpotWinnerInfo(data);
  }

  handleReconnected() {
    jackpotConnection.sendGameGetInitialState(false);
  }
}

export const jackpotService = new JackpotService();
